<div class="col-sm-12">
	<div class="card-box">
		<div id="info-content" style="height: 60px">{{text}}</div>
	</div>
</div>
